<template>
  <div
    :class="`milestone ${type}-milestone t-shadow`"
    :style="`${takt_index?
    `left: calc(${takt_index.index} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom) + ${takt_index.position} * (var(--workpackage_width) + 8px) * var(--taktplan_zoom) / ${takt_index.takt_length + 1});`:''}
    ${offset_y? `margin-top: calc(${offset_y} * calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) / 8));`:''}
    ${z_index? `z-index: ${z_index};` : isLarge? 'z-index: 10;' : ''}
    ${isLarge?`height: ${getZoom() * 25}px; width: ${getZoom() * 25}px; border-radius: ${getZoom() * 3}px;`:''}

    `"
    >
    <div
      id="milestone-token"
      class="milestone-token font-weight-light"
      :style="`${isLarge? `font-size: ${getZoom() * 12}px;`:''}`"
      >
      <slot>
        {{token}}
      </slot>
    </div>
    <div
      v-if="status != 'none' && status != undefined"
      id="milestone-badge"
      class="milestone-badge"
      :style="`${isLarge?`width: ${getZoom() * 12}px; height: ${getZoom() * 12}px; top: 0%; border-radius: ${getZoom() * 10}px; border: solid 1px #212121;`:''}`"
      >
      <v-icon
        id="milestone-badge-icon"
        class="milestone-badge-icon"
        :color="status === 'stop' ? 'red' : 'black'"
        :style="`${isLarge?`font-size: ${getZoom() * 10}px !important`:''};`"
        >
        <!-- done -->
        {{getStatusIcon(status)}}
      </v-icon>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  export default {
    props: ['token', 'takt_index', 'offset_y', 'distance_min', 'large', 'status', 'type', 'z_index', 'zoom'],
    computed: {
      ...mapGetters('View', [
        'getTaktplanZoom'
      ]),
      isLarge() {
        if (this.large) {
          return true
        } else {
          let workpackage_width = parseInt(getComputedStyle(document.body).getPropertyValue('--workpackage_width'));
          if (this.distance_min !== 0 && this.distance_min * (workpackage_width + 8) * this.getTaktplanZoom - ((workpackage_width + 8) * this.getTaktplanZoom / 8) > 12.5) {
            return true
          } else {
            return false
          }
        }
      },
    },
    // watch: {
    // '$props':{
    //   handler: function (val, old_val) {
    //     console.log(val.token, val.status, old_val.status, val, old_val)
    //   },
    //   deep: true
    //   }
    // },
    methods: {
      getZoom() {
        if (this.zoom) {
          return this.zoom;
        } else {
          return 1;
        }
      },
      getStatusIcon(currentStatus) {
        if (this.milestoneStatus.find(status => status.name === currentStatus)) {
          return this.milestoneStatus.find(status => status.name === currentStatus).icon;
        } else {
          return '';
        }
      }
    },
    data() {
      return {
        milestoneStatus: [
          {name: 'none', icon: ''},
          {name: 'done', icon: 'done'},
          {name: 'stop', icon: 'warning'}
        ]
      }
    }
  }
</script>
<style scoped>
  .project-milestone {
    background-color: white;
    color: black;
    border: 1px solid black;
  }
  .train-milestone {
    background-color: #121212;
    color: white;
    border: 1px solid white;
  }
  .new-project-milestone {
    background-color: #42A5F5;
    color: white;
  }
  .new-train-milestone {
    background-color: #121212;
    color: #42A5F5;
    border: 1px solid #42A5F5;
  }
  .milestone {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    /* height: 10px;
    width: 10px; */
    /* height: 25px;
    width: 25px; */
    width: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) / 8);
    height: calc((var(--workpackage_width) + 8px) * var(--taktplan_zoom) / 8);
    border-radius: 1px;
    transform: translate(-50%, -50%) rotate(45deg);
    transition: all 0.1s ease-in-out;
    cursor: pointer;
  }
  .milestone:hover {
    height: 25px;
    width: 25px;
    border-radius: 3px;
    z-index: 10;
  }
  .milestone-token {
    transform: rotate(-45deg);
    font-size: 0px;
    user-select: none;
    transition: all 0.1s ease-in-out
  }
  .milestone:hover #milestone-token {
    font-size: 12px;
  }
  .milestone-badge {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: rotate(-45deg);
    left: 50%;
    top: 50%;
    width: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8);
    height: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8);
    border-radius: 100%;
    background-color: white;
    z-index: 2;
    transform: translate(-50%, -50%);
    transition: all 0.1s ease-in-out

  }
  .milestone:hover #milestone-badge {
    width: 12px;
    height: 12px;
    top: 0%;
    border-radius: 10px;
    border: solid 1px #212121;
  }
  .milestone-badge-icon {
    transform: rotate(-45deg);
    font-size: calc((var(--workpackage_width) + 6px) * var(--taktplan_zoom) / 8) !important;
  }
  .milestone:hover #milestone-badge-icon {
    font-size: 10px !important;
  }
  .new {
    background-color: blue;
  }
  .milestone-icon {
    width: 16px;
    height: 16px;
    border-radius: 2px;
    transform: rotate(45deg);
    cursor: pointer;
    background-color: white;
    background-color: var(--v-primary-base);
  }
</style>
